export const ACTION = {
  ADD_INSTANCE: 'SELECTION_REPORT:ADD_INSTANCE',
  CLEAR_INSTANCE: 'SELECTION_REPORT:CLEAR_INSTANCE'
};

export class AddInstance {
  public type: string  = ACTION.ADD_INSTANCE;
  constructor(public instanceKey: string) {}
}

export class ClearInstance {
  public type: string  = ACTION.CLEAR_INSTANCE;
  constructor(public instanceKey: string) {}
}
